import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Hotel } from "lucide-react";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import GoogleButton from "@/components/GoogleButton";
export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}!`);
      navigate(u.role === "host" ? "/host" : u.role === "service_provider" ? "/provider" : (location.state?.from || "/"));
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="bg-white rounded-2xl border border-[#EBEBEB] p-8 shadow-sm">
        <div className="flex items-center justify-center mb-6">
          <div className="w-12 h-12 rounded-xl bg-[#FF385C] flex items-center justify-center">
            <Hotel className="w-6 h-6 text-white" />
          </div>
        </div>
        <h1 className="text-2xl font-display font-bold text-center mb-1">Welcome back</h1>
        <p className="text-sm text-[#717171] text-center mb-6">Log in to continue to Ixitrip</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email" className="mb-1 block text-sm">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="rounded-xl" />
          </div>
          <div>
            <Label htmlFor="password" className="mb-1 block text-sm">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Your password" className="rounded-xl" />
          </div>
          <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full rounded-xl bg-[#FF385C] hover:bg-[#D90B38] text-white h-11">
            {loading ? "Signing in..." : "Log in"}
          </Button>
        </form>
        <div className="mt-4"> <GoogleButton /> </div> 

        <div className="text-center text-sm text-[#717171] mt-6">
          New to Ixitrip?{" "}
          <Link data-testid="login-signup-link" to="/register" className="text-[#FF385C] font-semibold hover:underline">Create account</Link>
        </div>
      </div>
    </div>
  );
}
